import "./ServiceCardStyles.css"

import React from 'react'

// import { NavLink } from "react-router-dom"

const ServiceCard = (props) => {
  return (
    <div className="service-card">
        <img src={props.imgsrc} alt="serviceimage" />
        <h2 className="ser-title">{props.title}</h2>
        <div className="ser-details">
            <p>{props.text}</p>
        </div>
    </div>

  )
}

export default ServiceCard